  <img loading="lazy" alt="" *ngFor="let flag of flagArray" class="small-flag" [src]="getIconUrl(flag)">
